import { Observable, of } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ParentApiService } from './parent-api-service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { UserCreationRowErrorDto } from '../entities/user-creation-row-error-dto';

@Injectable({ providedIn: 'root' })
export class FileApiService extends ParentApiService {

    constructor(private http: HttpClient) {
        super();
    }

    public getImageById(imageId: number) {
        const url = `${environment.webApiAddress}/api/images?id=${imageId}`;
        return this.http.get(url, { responseType: 'blob' });
    }

    public getImageThumbnailById(imageId: number) {
        const url = `${environment.webApiAddress}/api/images/thumbnail?id=${imageId}`;
        return this.http.get(url, { responseType: 'blob' });
    }

    public putImages(images: FormData, stayOnPageIfError?: boolean): Observable<number[]> {
        const url = `${environment.webApiAddress}/api/images/upload`;
        return this.http.put<number[]>(url, images, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
    }

    public getPdfById(pdfId: number) {
        const url = `${environment.webApiAddress}/api/documents?id=${pdfId}`;
        return this.http.get(url, { responseType: 'blob' });
    }

    public putDocuments(pdfs: FormData, stayOnPageIfError?: boolean): Observable<number[]> {
        const url = `${environment.webApiAddress}/api/documents/upload`;
        return this.http.put<number[]>(url, pdfs, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
    }

    public saveLcaExcelFile(excel: FormData, stayOnPageIfError?: boolean) {
        const url = `${environment.webApiAddress}/api/life-cycle-data-import`;
        return this.http.post(url, excel, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
    }

    public putExcelUsers(formData: FormData, stayOnPageIfError?: boolean): Observable<any> {
        const url = `${environment.webApiAddress}/api/organizations/excel`;
        return this.http.put(url, formData,
                      { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, responseType: 'blob' })
            .pipe(catchError(this.parseErrorBlob));
    }

    public changePasswordsExcel(formData: FormData, stayOnPageIfError?: boolean): Observable<any> {
        const url = `${environment.webApiAddress}/api/organizations/change-passwords/excel`;
        return this.http.put(url, formData,
                      { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, responseType: 'blob' })
            .pipe(catchError(this.parseErrorBlob<UserCreationRowErrorDto[]>));
    }

    public putExcelPackagingUnit(formData: FormData, folderId?:number ,stayOnPageIfError?: boolean): Observable<any> {
      let url = `${environment.webApiAddress}/api/packaging-units/excel-upload`;
      if(folderId) {
          url += `?directoryId=${folderId}`
        }

        return this.http.put(url, formData, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
    }
}
